import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { Constants } from '../../models/constants';

@Component({
    selector: 'app-logout',
    templateUrl: './logout.component.html',
    styleUrls: ['./logout.component.scss']
})
export class LogoutComponent implements OnInit, OnDestroy {
    private subscriptions = new Subscription();

    isUserSettingError = false;
    isUserPermissionError = false;
    isNormalLogout = true;

    constructor(private readonly route: ActivatedRoute) {}

    ngOnInit(): void {
        this.subscriptions = this.route.queryParamMap.subscribe(paramMap => {
            if (paramMap.get('message') === Constants.UserSettingError) {
                this.isUserSettingError = true;
                this.isNormalLogout = false;
            } else if (paramMap.get('message') === Constants.UserPermissionError) {
                this.isUserPermissionError = true;
                this.isNormalLogout = false;
            }
        });
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
}
